import {
    Component,
    OnInit,
    ViewEncapsulation,
    Input,
    AfterViewInit,
    ElementRef,
    ViewChild,
    Output,
    EventEmitter
} from '@angular/core';

import { Calendar } from 'primeng/primeng';
import {
    IReservationRow
} from '../model/reservation';
import { DateString } from '../model/types';

export interface IMonthChangeEvent {
    month: number;
    year: number;
    start: DateString;
    stop: DateString;
}

export interface IEditEvent {
    date: DateString;
    reservations: number[];
}

@Component({
    selector: 'bb-calendar',
    template: require('./calendar.component.html'),
    styles: [
        require('./calendar.component.css'),
    ],
    encapsulation: ViewEncapsulation.None,
})

export class CalendarComponent extends Calendar implements OnInit, AfterViewInit {

    @Input() public inline: boolean = true;
    @Input() public reservations: {[id: string]: IReservationRow[]} = {};
    @Input() public reservationsLoaded: boolean = false;
    @Output() public monthChanged: EventEmitter<IMonthChangeEvent> = new EventEmitter<IMonthChangeEvent>();
    @Output() public onEdit: EventEmitter<IEditEvent> = new EventEmitter<IEditEvent>();
    @ViewChild('calendar') public calendarElement : ElementRef;

    public date1: Date;
    public fi: any;
    public tr: any;

    public ngOnInit() {
        this.locale = {
            today: '',
            clear: '',
            firstDayOfWeek: 1,
            monthNames: [
                'Tammikuu',
                'Helmikuu',
                'Maaliskuu',
                'Huhtikuu',
                'Toukokuu',
                'Kesäkuu',
                'Heinäkuu',
                'Elokuu',
                'Syyskuu',
                'Lokakuu',
                'Marraskuu',
                'Joulukuu'
            ],
            monthNamesShort: [
                'Tammi',
                'Helmi',
                'Maalis',
                'Huhti',
                'Touko',
                'Kesä',
                'Heinä',
                'Elo',
                'Syys',
                'Loka',
                'Marras',
                'Joulu'
            ],
            dayNamesShort: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'Su'],
            dayNames: ['Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai'],
            dayNamesMin: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
        };

        this.tr = {
            firstDayOfWeek : 1
        };

        this.yearNavigator = true;
        this.yearRange = '2017:2025';
        super.ngOnInit();
    }

    public ngAfterViewInit() {
        this.overlay = this.calendarElement.nativeElement;
    }

    public createMonth(month: number, year: number) {
        super.createMonth(month, year);
        let firstDay = this.dates[0][0],
            lastDay = this.dates[5][6];
        for (let week = 4; week < 6; week ++) {
            for (let weekDay = 0; weekDay < 7; weekDay ++) {
                if (!this.dates[week][weekDay].year) {
                    this.dates[week][weekDay].year = this.dates[week][weekDay].month === 0 ? year + 1 : year;
                }
            }
        }

        this.monthChanged.emit({
            month,
            year,
            start: this.dateStringFromDate(firstDay),
            stop: this.dateStringFromDate(lastDay),
        });
    }

    public onDateSelect(event: any, dateMeta: any) {
        super.onDateSelect(event, dateMeta);
    }

    public reservationsForDate(date : any) : IReservationRow[]|void {
        let dateStr = this.dateStringFromDate(date);

        return this.reservations && this.reservations[dateStr];
    }

    public edit(date : DateString) {
        let reservations : number[] = [];
        let r = this.reservationsForDate(date);

        if (Array.isArray(r)) {
            for (let reserevation of r) {
                if (reservations.indexOf(reserevation.reservationId) === -1) {
                    reservations.push(reserevation.reservationId);
                }
            }
        }

        this.onEdit.emit({date, reservations});
    }

    private dateStringFromDate(date : any) : string {
        return date.year + '-' + this.zeroPad(date.month + 1) + '-' + this.zeroPad(date.day);
    }

    private zeroPad(value : number) : string {
        return (value < 10 ? '0' : '') + value;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/calendar/calendar.component.ts